import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";

import Footer from "../../layouts/Footer";
import Header from "../../layouts/Header";
import Layout from "../../layouts/Layout";
import BackButton from "../../components/BackButton";
import { FormattedMessage } from "react-intl";
import image from "./sources/image.jpg";
import { contactPageConfig } from "./constants/ContactPageConfig";
import messages from "./constants/messages";
import { styles } from "./constants/styles";

type Props = WithStyles<typeof styles>;

const ContactPage: React.FC<Props> = (props: Props) => {
  const renderItem = (item) => {
    const { classes } = props;
    if (item.link) {
      return (
        <Typography key={item.id}>
          {item.prefix}{" "}
          <a className={classes.link} href={item.link}>
            {item.localized ? <FormattedMessage {...item.value} /> : item.value}
          </a>
        </Typography>
      );
    } else {
      return (
        <Typography key={item.id}>
          {item.prefix} {item.localized ? <FormattedMessage {...item.value} /> : item.value}
        </Typography>
      );
    }
  };

  const { classes } = props;
  return (
    <Layout>
      <Header />
      <div className={classes.root}>
        <div className={classes.titleGroup}>
          <BackButton/>
          <Typography className={classes.title}>
            <FormattedMessage {...messages.title} />
          </Typography>
        </div>
        <Typography className={classes.subtitle}>
          <FormattedMessage {...messages.subtitle} />
        </Typography>
        <img src={image} alt="avatar" className={classes.image} />
        {contactPageConfig.map((item) => renderItem(item))}
      </div>
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(ContactPage);
